import Rellax from 'rellax';

var rellax = new Rellax('.rellax', {
  center: true,
  speed: -4
});
